import { render, staticRenderFns } from "./RegVideo.vue?vue&type=template&id=30453f55&scoped=true&"
import script from "./RegVideo.vue?vue&type=script&lang=js&"
export * from "./RegVideo.vue?vue&type=script&lang=js&"
import style0 from "./RegVideo.vue?vue&type=style&index=0&id=30453f55&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30453f55",
  null
  
)

export default component.exports